module.exports = __webpack_public_path__ + "static/media/avair.c28358f7.png";